import {css, html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent.js'
import SftpService from '../../services/SftpService.js'
import '@isceco/widget-library2/basic-elements/FileInput/FileInput.js'
import GasmonitoringFileInputService from '../../services/GasmonitoringFileInputService.js'
import '@isceco/widget-library2/basic-elements/Card/Card.js'


export default class Sftp extends WebComponent {

  constructor() {
    super()
    this.sftpService = new SftpService()
  }

  get translationFile() {
    return './views/Sftp/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.files = {}
    this.url = ""

    this._fetchData()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  get css() {
    return css`
          .gridRow {
            display: grid;
            align-items: center;
            grid-template-columns: 0.7fr 1.2fr 0.5fr 1.5fr;
          }
        `
  }

  _fetchData() {
    this.sftpService.getfiles()
      .then(files => {
        this.files = files
        this.sftpService.getImportBackendListUrl().then(url => {
          this.url = url
          this.render()
        })
      })
      .catch(_ => {
        showAlert(this.i18n.translate('admin.sftp.failure'), '', 'error')
        this.render()
      })
  }

  getTemplate() {
      if (this.files.length === 0) {
        return html``
      }

      const files = this.files.map((file, index) => html`
        <div class="gridRow">
          <div>
            ${formatDateTime(file.lastModified)}
          </div>
          <div>
            <isceco-button
              variant="tertiary"
              size="small"
              text="${file.fileName}"
              @click="${_ => this.sftpService.download(file.filePath, file.fileName)}"
            ></isceco-button>
          </div>
          <div>
            ${file.filePath}
          </div>
          <div>
            <isceco-file-input
              id="file-upload-button"
              .fileInputService="${new GasmonitoringFileInputService(`${this.url}/upload/${file.filePath}`)}"
              @change="${e => this._onDokumentUploaded(e)}"
            ></isceco-file-input>
          </div>
        </div>
      `)

      return html`
        <isceco-card text="${this.i18n.translate('admin.sftp.title')}">
          <div class="gridRow" style="font-size: medium; font-weight: bold;">
            <div>
              ${this.i18n.translate('admin.sftp.letzteaenderung')}
            </div>
            <div style="padding-left: 12px;">
              ${this.i18n.translate('admin.sftp.filename')}
            </div>
            <div>
              ${this.i18n.translate('admin.sftp.verzeichnis')}
            </div>
            <div>
              ${this.i18n.translate('admin.sftp.upload')}
            </div>
          </div>
        ${files}
        </isceco-card>
      `
  }

  _onDokumentUploaded(e) {
    if (e.detail.valid) {
      showAlert(this.i18n.translate('admin.sftp.upload.success'), '', 'success')
      this._fetchData()
    }
  }

}

customElements.define('gasmonitoring-frontend-admin-sftp-view', Sftp)
